import { Component, OnInit, ViewChild }                             from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators }      from '@angular/forms';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';
import { NgxSpinnerService }                                        from 'ngx-spinner';

import { AlertService, ProctorService }                             from '../_services';
import { Globals }                                                  from '../_helpers';
import { SearchFilterPipe }                                         from '../_pipes';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-studentlist',
    templateUrl: './studentlist.component.html'
})


export class StudentlistComponent implements OnInit {

    statusMsg: string = '';
    batch_name: string = '';
    exam_name: string = '';
    exam_date;
    localData = {};
    localBatch = {};
    localExam = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    studentData = [];
    query: string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}

  	ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.localBatch = JSON.parse(localStorage.getItem('localBatch'));
        this.localExam = JSON.parse(localStorage.getItem('localExam'));

        if(this.localData['is_report'] != 1)
            this.router.navigateByUrl('/login');

        this.getStudentDetailsByExam();

        this.batch_name = this.localBatch['batch_name'];
        this.exam_name = this.localBatch['exam_name'];
        this.exam_date = this.localBatch['exam_date'];
        
  	}

  	private getStudentDetailsByExam(){
        this.spinner.show();
  		this.submitted = true;
        this.proctorService.getExamStudents(this.globals.root_url, this.localData['usercode'], this.localExam['exam_id'])
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this.studentData = data.students;
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status, '/exams');
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
  	}

    public reportView(student_id:number){
        localStorage.setItem('localStudent', JSON.stringify({student_id:student_id}));
        this.router.navigateByUrl('/report');
    }

}


